<template>
  <v-row no-gutters v-if="golfVlogLanguage.length > 5">
    <v-dialog v-model="dialog" scrollable max-width="250px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          class="pl-0 success--text text-capitalize more-btn"
          style="height: auto"
          v-bind="attrs"
          v-on="on"
        >
          <translate class="text-subtitle-2">More</translate>
          <v-icon
            class="fal fa-chevrons-right pl-2"
            color="success"
            size="13"
          ></v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-text style="height: 300px; padding: 0 15px justify-center">
          <v-radio-group v-model="languageDefault" column>
            <v-radio
              v-for="language in golfVlogLanguage"
              :key="language.id"
              :value="language.id"
              @change="chooseLanguage(language.id)"
            >
              <template v-slot:label>
                <div class="black--text text-subtitle-2" v-if="language.count">
                  {{ language.name }}
                  <span class="gray3--text text-subtitle-2">({{ language.count }})</span>
                </div>
                <div class="black--text text-subtitle-2" v-else>
                  {{ language.name }}
                  <span class="gray3--text text-subtitle-2">({{ totalVlog }})</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary darken-1" text @click="dialog = false">
            <translate class="text-subtitle-2">Close</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: "DialogLanguage",
  props: ["totalVlog"],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    languageDefault: {
      get() {
        return this.$store.state.post.languageDefaultVlog;
      },
      set(value) {
        this.$store.commit("post/setDefaultLanguageVlog", value);
      },
    },
    golfVlogLanguage() {
      return this.$store.state.post.golfVlogLanguage;
    },
  },
  methods: {
    chooseLanguage(value) {
      this.dialog = false;
      this.$emit("chooseLanguage", value);
    },
  },
};
</script>
<style>
.more-btn .v-btn__content {
  font-size: 1rem;
}
</style>